import HabeasDataServicesImpl from "./habeas_data_services_impl";

export default {
  getHabeasData: async () => {
    return HabeasDataServicesImpl.getHabeasData();
  },
  getHabeasDataBySearch: async (term) => {
    return HabeasDataServicesImpl.getHabeasDataBySearch(term);
  },
  getHabeasDataBySearching: async (data) => {
    return HabeasDataServicesImpl.getHabeasDataBySearching(data);
  } 
};
